<section class="cross-sell-card">

  <div class="d-flex gap-2">

    <div class="position-relative">
      <div class="cross-sell-card__img">
        <img class="cross-sell-card__img" [src]="selectedAttributeCardConfig().image" alt="Image of product"
          (error)="handleImageError($event)" />
      </div>
      @if(selectedAttributeCardConfig().hasDiscount && selectedAttributeCardConfig().isOnSale) {
      <div class="cross-sell-card__sale">
        <span class="material-symbols-outlined">
          percent
        </span>
      </div>
      }
    </div>

    <div class="d-flex flex-column justify-content-center gap-2 w-100">

      <span class="cross-sell-card__name" [ngbTooltip]="card().product.name"
        [routerLink]="[`/shop/${card().product.productUrl}`]">
        {{card().product.name}}
      </span>

      <div class="d-flex justify-content-between align-items-center">

        <div class="d-flex flex-column">

          <div>
            <span class="h6-semibold">
              {{ selectedAttributeCardConfig().price | currency }}
            </span>

            @if(selectedAttributeCardConfig().hasDiscount) {
            <span>
              <small class="h7-semibold text-body-tertiary text-decoration-line-through">
                {{selectedAttributeCardConfig().originalPrice | currency}}
              </small>
            </span>
            }
          </div>

          @if (selectedAttributeCardConfig().display) {
          <span class="h8-semibold">
            {{selectedAttributeCardConfig().display || ''}}
          </span>
          }

        </div>

        <button class="btn btn-primary cross-sell-card__add" type="button"
          (click)="outAddProductToCart.emit({isSubscription: false, event: $event, isFromCrossSell: true})">
          <span class="material-symbols-outlined">
            add
          </span>
        </button>

      </div>

    </div>

  </div>

  @if (productAttributes().length) {
  @for (attr of productAttributes(); track $index) {
  @if (attr?.values?.length && !card().product.variantId && attr?.values?.length > 1) {
  <div class="row">
    <div class="col-12 d-flex gap-1">
      <mat-form-field class="rounded-selector" subscriptSizing="dynamic">
        <mat-label class="text-capitalize">{{attr.name.toLowerCase()}}</mat-label>
        <mat-select [value]="selectedAttribute()?.value?.id || ''"
          (selectionChange)="outOnAttributeChange.emit({id: attr.id, event: $event})">
          @for (item of attr.values; track $index) {
          <mat-option [value]="item.id">{{item.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  }
  }
  }

  @if (card().product.packages?.length) {
  <div class="row">
    <div class="col-12 d-flex gap-1">
      <mat-form-field class="rounded-selector" subscriptSizing="dynamic">
        <mat-label class="text-capitalize">Package</mat-label>
        <mat-select [value]="selectedPackage()?.id || ''" (selectionChange)="outOnPackageChanged.emit($event.value)">
          @for (item of card().product.packages; track $index) {
          <mat-option [value]="item.id">{{item.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  }


</section>